import React, { useCallback, useEffect } from 'react';
import './Modal.styles.css';
import { useNavigate } from 'react-router-dom';

interface ModalProps {
  children: React.ReactNode;
  navigateTo: string | number;
}

export const Modal: React.FC<ModalProps> = ({ children, navigateTo }) => {
  const navigate = useNavigate();

  // The branches narrow the string|number union for navigate's overloads.
  const onNavigateBack = useCallback(() => {
    if (typeof navigateTo === 'number') {
      navigate(navigateTo);
    } else {
      navigate(navigateTo);
    }
  }, [navigate, navigateTo]);

  // Close on Escape (backdrop click already closes).
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onNavigateBack();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onNavigateBack]);

  return (
    <div className="modal" >
      <Backdrop onNavigateBack={onNavigateBack}>
        {children}
      </Backdrop>
    </div>
  );
};

interface BackdropProps {
  children: React.ReactNode;
  onNavigateBack: () => void;
}

const Backdrop: React.FC<BackdropProps> = ({ children, onNavigateBack }) => {

  return (
    <>
      <div onClick={onNavigateBack} className="backdrop"></div>
      {children}
    </>
  );
};
